import ABCyaLib from "@abcya/abcya_lib";

export default function setupGameConfig(variantId, locale) {
  const config = {
    // add your game config options here, these can be the default values
    countingTitleFontSize: 110,
    maxHowOldIsTextWidth: 330,
    decorateAnotherCakeTextFontSize: 32
  };
  switch (locale) {
    case ABCyaLib.Environment.LOCALES.esUS:
      config.countingTitleFontSize = 95;
      config.maxHowOldIsTextWidth = 300;
      config.decorateAnotherCakeTextFontSize = 28;
      break;
  }
  return config;
}